import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CutsProjectModel } from '@core/model/custProject.model';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { DimensionModel } from '@core/model/dimension.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { SiteModel } from '@core/model/site.model';
import { UserModel } from '@core/model/user.model';
import { ModalSuccessComponent } from '@shared/modal/modal-success/modal-success.component';
import { CommonService } from '@shared/service/common.service';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { utiles } from '@utl/environment';
import { ItemService } from '@shared/service/items.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommentProductModel } from '@core/model/commentProduct.model';
import { ItemRatingModel } from '@core/model/itemRating.model';
import { ModalQualificationComponent } from '@shared/modal/modal-qualification/modal-qualification.component';
import { SendItemModel } from '@core/model/sendItem.model';
import { environment } from '@env/environment';
declare var ImageZoom: any;

@Component({
  selector: 'app-productinformation',
  templateUrl: './productinformation.component.html',
  styleUrls: ['./productinformation.component.scss']
})
export class ProductinformationComponent implements OnInit, OnDestroy, OnChanges {

  @Input() parentData
  @Input() FamilyId

  public itemInfoModel: ItemInformationModel;
  public productInformation: ItemInformationModel;
  private unsubscribe$ = new Subject<void>();
  productImage: any[] = [];
  public colorSelected = '';
  public estiloSelected = '';
  public tamanoSelected = '';
  public configSelected = '';
  public colorId = 'color';
  public estiloId = 'estilo';
  public tamanoId = 'tamano';
  public configId = 'config';
  showRelated = false;
  showItemNoPrice = false;
  enableCartButton = true;
  public dimensionColor: DimensionModel[] = [];
  public dimensionEstilo: DimensionModel[] = [];
  public dimensionTamano: DimensionModel[] = [];
  public dimensionConfig: DimensionModel[] = [];
  public dimensions: DimensionModel[] = [];
  family = '';
  all = 'all';
  count = 0;
  hovered: any;
  options = {
    width: 437,
    zoomWidth: 300,
    zoomStyle: 'z-index: 1;margin-left: 5rem;',
    offset: { vertical: 0, horizontal: 10 }
  };
  imgDefault = environment.imgDefault;
  enableNotMasterProduct = false;
  isRating = false;
  isFirstLoadingPrice = true;
  isFirstLoading = true;
  public sendItemModel: SendItemModel = new SendItemModel();
  masterClientModel: MasterClientModel = new MasterClientModel();
  private userModel: UserModel;
  private siteModel: SiteModel = new SiteModel();
  private currencyModel: any;
  private projectModel: CutsProjectModel = new CutsProjectModel();
  private projectCustomer: CutsProjectModel = new CutsProjectModel();
  mostrarCancelar: boolean = false;
  imageSelected: any;
  onCancel = new EventEmitter();
  isShoppingModal = 0;
  redirect: boolean = false;

  constructor(
    private productFamilyService: ProductFamilyService,
    private itemService: ItemService,
    public dialog: MatDialog,
    private common: CommonService,
    private router: Router,
  ) { }

  ngOnChanges(): void {
    this.uploadInformation();
    //this.enableCartButton = true;
  }

  ngOnInit(): void {

    this.currencyModel = utiles.getCacheSelectedCurrency();
    this.itemInfoModel = new ItemInformationModel();
    this.setUserData();

    this.common.SelectedSite.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (site) => {
        if (site !== null) {
          this.siteModel = site;
        }
      }
    );
    // Observable of the selected project
    this.common.SelectedProject.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (project) => {
        if (project !== null) {
          this.projectModel = project;
        }
      }
    );

    // Observable para redireccionar al agregar
    this.common.UpdateRedirectCart.pipe(takeUntil(this.unsubscribe$)).subscribe((update) => {
      if (update) {
        if (this.mostrarCancelar) {
          this.cancel(this.redirect);
        } else {
          if(this.redirect === false) {
            this.router.navigate(['shoppingcart']);
          }
        }
        this.common.setUpdateRedirectCart(false);
      }
    });

    this.common.SelectedClient.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (client) => {
        if (client !== null && client !== '') {
          this.projectCustomer = client;
          this.masterClientModel = client;
        }
      }
    );

    this.common.SelectedCurrency.pipe(takeUntil(this.unsubscribe$)).subscribe(currency => {
      if (currency !== null) {
        if (this.currencyModel.CurrencyId !== currency.CurrencyId) {
          this.currencyModel = currency;
        }
      }
    });

    this.uploadInformation();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

  }

  setUserData() {
    this.userModel = utiles.getCacheUser();
  }

  uploadInformation () {
    this.isShoppingModal = 0;
    if (this.parentData === undefined) {
      this.isShoppingModal = 1;
      let data = utiles.getCacheProductShopping();
      this.parentData = new ItemInformationModel();
      this.parentData.ItemId = data.itemInfo.ItemId;
      this.parentData.UserId = this.userModel.UserId;
      this.parentData.colorSelected = '';
      this.parentData.estiloSelected = '';
      this.parentData.tamanoSelected = ''
      this.parentData.configSelected = ''
      if (this.currencyModel !== undefined) {
        this.parentData.Currency = this.currencyModel.CurrencyId;
      }
      this.parentData.ProjectId = this.projectModel.ProjectId;
      this.parentData.CustAccount = this.masterClientModel.CustAccount;

      let itemIdCheck = this.parentData.ItemId
      if (itemIdCheck.startsWith("010") === true) {
        if (this.FamilyId !== undefined && this.FamilyId !== '')
          this.parentData.family = this.FamilyId;
        else
          this.parentData.family = data.family;

        this.FamilyId = this.parentData.family;
      }


      this.mostrarCancelar = true;
    }
    
    this.getProductDetail(true);
  }

  getProductDetail(_isFirstLoading) {

    this.productInformation = new ItemInformationModel();

    this.productInformation.ItemId = this.parentData.ItemId;
    this.productInformation.UserId = this.parentData.UserId;
    if (_isFirstLoading) {
      this.productInformation.Color = this.parentData.Color;

      let itemIdCheck = this.parentData.ItemId
      if (itemIdCheck.startsWith("010") === true) {
        this.FamilyId = 'ALUMINIO';
      } else {
        this.FamilyId = '';
      }

      if (this.FamilyId === 'ALUMINIO') {
        this.parentData.estiloSelected = '6063T5';
        this.productInformation.Style = this.parentData.estiloSelected;
      } else {
        this.productInformation.Style = this.parentData.Style;
      }

      this.productInformation.Size = this.parentData.Size;
      this.productInformation.Config = this.parentData.Config;
    } else {
      this.productInformation.Color = this.colorSelected
      if (this.FamilyId === 'ALUMINIO') {
        this.estiloSelected = '6063T5';
        this.productInformation.Style = this.estiloSelected;
      } else {
        this.productInformation.Style = this.estiloSelected;
      }
      this.productInformation.Size = this.tamanoSelected;
      this.productInformation.Config = this.configSelected;
    }


    if (this.productInformation.Color !== '') {
      this.colorSelected = this.productInformation.Color;
    } else {
      this.colorSelected = '';
    }
    if (this.productInformation.Style !== '') {
      this.estiloSelected = this.productInformation.Style;
    } else {
      this.estiloSelected = '';
    }
    if (this.productInformation.Size !== '') {
      this.tamanoSelected = this.productInformation.Size;
    } else {
      this.tamanoSelected = '';
    }

    if (this.currencyModel !== undefined) {
      this.productInformation.Currency = this.currencyModel.CurrencyId;
    }
    this.productInformation.CustAccount = this.parentData.CustAccount;
    this.productInformation.ProjectId = this.parentData.ProjectId;

    this.productInformation.ConsultarInformacion(this.productFamilyService)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        if (response != null) {
          this.itemInfoModel = response;
          console.log("Price:", this.itemInfoModel.SinglePrice, _isFirstLoading);
            this.productImage = JSON.parse(response.ImageList);
            if (this.productImage.length > 0) {
              if (this.isShoppingModal === 1) {
                document.images['image-product-modal'].src = this.productImage[0].URLImage;
              } else {
                document.images['image-product'].src = this.productImage[0].URLImage;
              }
            } else {
              if (this.isShoppingModal === 1) {
                document.images['image-product-modal'].src = '../../../assets/img/Filtro.png';
              } else {
                document.images['image-product'].src = '../../../assets/img/Filtro.png';
              }
            }
            console.log("Verify:", this.verifyChange());
            if (this.verifyChange() && this.itemInfoModel.SinglePrice === 0) {
              this.enableCartButton = true;
              if (this.colorSelected !== '' || this.estiloSelected !== '') {
                this.showItemNoPrice = true;
              }
            } else {
              this.showItemNoPrice = false;
            }
        } else {
          document.images['image-product'].src = '../../../assets/img/Filtro.png';
            this.itemInfoModel = new ItemInformationModel();
            this.itemInfoModel.SinglePrice = 0;
            this.itemInfoModel.DiscountAmount = 0;
            //this.itemInfoModel.ProductByFamily = [];
            this.itemInfoModel.CommentUserInfo = [];
            this.itemInfoModel.Favorite = 0;
            this.showRelated = false;
            this.showItemNoPrice = true;
            this.showNoDetailProd();
        }
        
        this.limpiarZoom();
        if(this.productImage.length > 0 && this.productImage[0].URLImage !== "" && this.productImage[0].URLImage !== undefined) {
          this.showImage(this.productImage[0].URLImage);
        } else {
          this.showImage('../../../assets/img/Filtro.png');
        }
        
        this.getProductDimensions();
      });
  }

  getProductDimensions() {

    this.productFamilyService.getInventDimensionsByItems(this.itemInfoModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response != null) {
            this.dimensions = response;
            this.dimensionColor = response;
            let hash = {};
            this.dimensionColor = this.dimensionColor.filter(function(current) {
              let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
              hash[current.Color] = true;
              return exists;
            });
            this.dimensionEstilo = response;
            let hash2 = {};
            this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
              let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
              hash2[current.Estilo] = true;
              return exists;
            });
            this.dimensionTamano = response;
            let hash3 = {};
            this.dimensionTamano = this.dimensionTamano.filter(function(current) {
              let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
              hash3[current.Tamano] = true;
              return exists;
            });
            this.dimensionConfig = response;
            let hash4 = {};
            this.dimensionConfig = this.dimensionConfig.filter(function(current) {
              let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
              hash4[current.Config] = true;
              return exists;
            });
            if (this.colorSelected !== '') {
              this.setDimensionsValue(this.colorSelected, 'color');
            }
            if (this.estiloSelected !== '') {
              this.setDimensionsValue(this.estiloSelected, 'estilo');
            }
            if (this.tamanoSelected !== '') {
              this.setDimensionsValue(this.tamanoSelected, 'tamano');
            }
            if (this.configSelected !== '') {
              this.setDimensionsValue(this.configSelected, 'config');
            }
          }

          if (this.verifyChange() && this.itemInfoModel.SinglePrice !== 0) {
            this.enableCartButton = false;
            this.isFirstLoading = false;
          }
        });
  }

  setDimensionsValue(value, type) {
    // If a see all in any combo is selected, all available options are shown
    if (value === 'all') {
      this.dimensionColor = [];
      this.dimensionEstilo = [];
      this.dimensionTamano = [];
      this.dimensionConfig = [];
      this.colorSelected = '';

      if (this.FamilyId !== 'ALUMINIO')
        this.estiloSelected = '';

      this.tamanoSelected = '';
      this.configSelected = '';
      this.enableCartButton = true;
      this.dimensions.forEach(item => {
        this.dimensionColor.push(item);
        this.dimensionEstilo.push(item);
        this.dimensionTamano.push(item);
        this.dimensionConfig.push(item);
      });

      let hash = {};
      this.dimensionColor = this.dimensionColor.filter(function(current) {
        let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
        hash[current.Color] = true;
        return exists;
      });
      let hash2 = {};
      this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
        let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
        hash2[current.Estilo] = true;
        return exists;
      });
      let hash3 = {};
      this.dimensionTamano = this.dimensionTamano.filter(function(current) {
        let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
        hash3[current.Tamano] = true;
        return exists;
      });
      let hash4 = {};
      this.dimensionConfig = this.dimensionConfig.filter(function(current) {
        let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
        hash4[current.Config] = true;
        return exists;
      });
    } else {
      // Each combo is filtered based on the selected value and type
      switch (type) {
        case 'color':
          this.filterTamano(value, type);
          this.filterEstilo(value, type);
          this.filterConfig(value, type);
          break;
        case 'estilo':
          this.filterColor(value, type);
          this.filterTamano(value, type);
          this.filterConfig(value, type);
          break;
        case 'tamano':
          this.filterColor(value, type);
          this.filterEstilo(value, type);
          this.filterConfig(value, type);
          break;
        case 'config':
          this.filterColor(value, type);
          this.filterEstilo(value, type);
          this.filterTamano(value, type);
          break;
      }
    }
  }

  filterColor(value, type) {
    this.dimensionColor = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionColor.push(item);
          }
          break;
      }
    });
    let hash = {};
    this.dimensionColor = this.dimensionColor.filter(function(current) {
      let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
      hash[current.Color] = true;
      return exists;
    });
  }

  filterEstilo(value, type) {
    this.dimensionEstilo = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionEstilo.push(item);
          }
          break;
      }
    });
    let hash2 = {};
    this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
      let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
      hash2[current.Estilo] = true;
      return exists;
    });
  }

  filterTamano(value, type) {
    this.dimensionTamano = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionTamano.push(item);
          }
          break;
      }
    });
    let hash3 = {};
    this.dimensionTamano = this.dimensionTamano.filter(function(current) {
      let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
      hash3[current.Tamano] = true;
      return exists;
    });
  }

  filterConfig(value, type) {
    this.dimensionConfig = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionConfig.push(item);
          }
          break;
      }
    });
    let hash4 = {};
    this.dimensionConfig = this.dimensionConfig.filter(function(current) {
      let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
      hash4[current.Config] = true;
      return exists;
    });
  }

  showNoDetailProd() {
    let data = new DataMessageModel();
    data.labelTitile = 'Producto no disponible.';
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      data,
      minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh', disableClose: true
    });
    dialogRef.afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        dialogRef.close();
        this.router.navigate(['dashboard']);
      });
  }

  verifyChange() {
    let getDetail = false;

    if (this.dimensionColor.length > 0) {
      if (this.colorSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionEstilo.length > 0 && this.family !== 'ALUMINIO') {
      if (this.estiloSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionTamano.length > 0) {
      if (this.tamanoSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionConfig.length > 0) {
      if (this.configSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }

    return getDetail;
  }

  async goToShoppingCart(_onlyAdd: boolean) {
    this.redirect = _onlyAdd;
    await this.productInformation.AgregarCarrito(this.itemService, this.dialog, this.common);
  }

  changeCombo(value, type) {
    if (value === 'all') {
      this.colorSelected = '';
      if (this.FamilyId !== 'ALUMINIO')
        this.estiloSelected = '';

      this.tamanoSelected = '';
      this.configSelected = '';
      this.enableCartButton = true;
      this.itemInfoModel.SinglePrice = 0;
    }
    if (this.verifyChange()) {
      this.enableCartButton = false;
      this.getProductDetail(false);
    } else {
      this.setDimensionsValue(value, type);
    }
  }

  cancel(_onlyAdd: boolean) {
    this.onCancel.emit(_onlyAdd);
    utiles.clearCacheProductShopping();
  }

  onRateChange(rating: any) {
    if (this.itemInfoModel.AllowComment === 1) {
      this.openModal(rating);
    }
  }

  openModal(rating) {
    let alreadyComment = this.itemInfoModel.CommentUserInfo.find(x => x.UserEmail === this.userModel.ExtralumEmail);

    if (alreadyComment !== undefined && alreadyComment !== null) {
      let data = new DataMessageModel();
      data.labelTitile = 'El artículo ya ha sido calificado.';
      const dialogRef = this.dialog.open(ModalSuccessComponent, {
        data,
        minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh', disableClose: true
      });
    } else {
      let ratingData = new CommentProductModel();
    ratingData.Qualification = rating.ItemRating;
    ratingData.FullName = this.userModel.UserName + ' ' + this.userModel.UserLastName;
    const dialogRef = this.dialog.open(ModalQualificationComponent, {
      data: {
        labelTitile: '¿Qué te pareció nuestro producto?',
        status: 'success',
        ratingData,
      },
      minWidth: '40vw', maxWidth: '85vw', maxHeight: '85vh', minHeight: '40vh'
    });
    setTimeout(() => dialogRef.close(), 100000);

    dialogRef.componentInstance.onAccept
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result: CommentProductModel) => {
        let itemRating = new ItemRatingModel();
        itemRating.ItemId = this.itemInfoModel.ItemId;
        itemRating.Rating = result.Qualification;
        itemRating.Comment = result.Comment;
        itemRating.UserId = this.userModel.UserEmail;
        this.saveRatingInformation(itemRating);
        dialogRef.close();
      });
    }
  }

  saveRatingInformation(itemRating: ItemRatingModel) {
    this.productFamilyService.saveRatingInformation(itemRating)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.getProductDetail(false);
        },
      );
  }

  goToModelVCProduct(item) {
    this.router.navigate(['modelvc'], {
      queryParams: {
        Model: undefined,
        Item: JSON.stringify(this.itemInfoModel.ItemId),
        Estilo: JSON.stringify(this.estiloSelected),
        Color: JSON.stringify(this.colorSelected),
        Lamina: true
      },
    });
  }

  addFavorite(ItemId) {
    this.sendItemModel.UserId = this.userModel.UserId;
    this.sendItemModel.ItemId = ItemId;
    this.productFamilyService.addToFavoriteItems(this.sendItemModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response) {
            this.itemInfoModel.Favorite = 1;
          }
        },
      );
  }

  limpiarZoom() {
    let i = 0;
    let container = document.getElementById('img-container');
    container.childNodes.forEach(element => {
      if(element.nodeName === "DIV")
        element.remove();
    });

    if(this.isShoppingModal === 0) {
      let divImage = document.getElementById('image-product');
      divImage.childNodes.forEach(element => {
        divImage.removeChild(element);
      });
    }
    else {
      let divImage = document.getElementById('image-product-modal');     // Get the <ul> element with id="img-container"
      divImage.childNodes.forEach(element => {
        divImage.removeChild(element);
      });
    }
  }

  showImage(URLImage) {
    if(this.isShoppingModal === 1)
      document.images['image-product-modal'].src = URLImage;
    else
      document.images['image-product'].src = URLImage;

    this.limpiarZoom();
    ImageZoom(document.getElementById('img-container'), this.options);
  }

  deleteFavorite(ItemId) {
    this.sendItemModel.UserId = this.userModel.UserId;
    this.sendItemModel.ItemId = ItemId;
    this.productFamilyService.deleteFromFavorite(this.sendItemModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response) {
            this.itemInfoModel.Favorite = 0;
          }
        },
      );
  }

  imageAddress(img) {
    this.imageSelected = '';
    this.imageSelected = img;
  }

}
